import { defineStore } from "pinia";
import api from "@/services/useApi";

export const usePatientStore = defineStore("patient", {
  state: () => ({
    patient: null,
    schedule: null,
  }),
  actions: {
    async createPatient(patientData) {
      const response = await api.post("/registration/patient", patientData);

      return response.data;
    },
    async updatePatient(patientData) {
      const response = await api.patch("/registration/patient", patientData);

      return response.data;
    },
    async getPatientFilters(params) {
      const response = await api.get("/registration/get-patient-id", {
        params,
      });

      return response.data;
    },

    setPatientData(patientData) {
      this.patient = patientData;
    },
    setScheduleData(scheduleData) {
      this.schedule = scheduleData;
    },
  },
});
